import React, { useState, useEffect } from "react";
import {
  MULTI_CHOICE,
  RULE_SUGESSTION_OPTIONS,
  RULE_FEATURE_TYPE_OPTIONS,
  RULE_OPERATOR_OPTIONS,
  CREATE_NEW_CONDITION,
  RULE_VALIDATION_MESSAGE,
  RULE_NAME_MANDATORY_MESSAGE,
  RULE_SAVE_MESSAGE,
  RULE_UPDATE_MESSAGE,
  RULE_CONDITION,
  RULE_DONE,
  RULE_RULE,
  RULE_EXPRESSION,
  RULE_SELECT,
  RULE_OPERATOR,
  RULE_FUNCTION_SAVE,
  RULE_FUNCTION_EDIT,
  RULE_FUNCTION_DELETE,
  RULE_FUNCTION_RULE_NAME,
  RULE_NAME,
  RULE_DESCRIPTION,
  RULE_FEATURE_TYPE,
  RULE_FEATURE,
  RULE_FUNCTION_PARENT,
  RULE_FUNCTION_CONDITION,
  RULE_FUNCTION_EXPRESSION,
  RULE_FUNCTION_CHILD,
  RULE_FUNCTION_ADD,
  RULE_FUNCTION_0,
  RULE_FUNCTION_1,
  RULE_FUNCTION_2,
  RULE_FUNCTION_3,
  RULE_EMPTY_STRING,
  RULE_FUNCTION_SUBMODEL,
  RULE_FUNCTION_SUBMODEL_FIELD,
  RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
  RULE_FUNCTION_FIELD,
  RULE_FUNCTION_CATEGORY,
  RULE_FUNCTION_CONNECTOR,
  RULE_ADD_FIELD,
  RULE_FUNCTION_DESCRIPTION,
  RULE_SAVE, RANGE_FIELD,
} from "../../ISRConstants";
import TextField from "Components/DesignSystem/TextField/TextField";
import FieldTitle from "Components/DesignSystem/FieldTitle/FieldTitle";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";
import Button from "Components/DesignSystem/Button/Button";
import MathOperator from "../MathOperator/mathOperatorComponent";
import SelectOptionsView from "../SelectOptionsView";
import { EditIcon, DeleteIcon } from "assests/GmsIcons";
import {
  RuleObjectStateType,
  RuleObjectType,
  TCategory,
  TRuleObj,
} from "../../Pages/DefineModel/model";
import { toast } from 'Components/DesignSystem/Toast/useToast';
import {
  TConnector,
  TField,
  TFieldDataConfiguration,
  TIndexState,
  TProductCategory,
  TSubmodel,
  TUpsertISRProjectDataModelsInput,
  TFieldAdditionalData,
  RuleSuggestionOptionType,
  RuleOptionType,
  TTransformation,
  TClass,
} from "../../Pages/DefineModel/model";
import { TAttributeChoice } from "types/Pages/ProductDelta";

type ConditionalRuleComponentPropType = {
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  setUserProjectDataModels: React.Dispatch<
    React.SetStateAction<TUpsertISRProjectDataModelsInput>
  >;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo?: TIndexState;
  editId?: any;
  ruleType: any;
  toggleMenu: () => void;
  createISRProject:(isRuleUpdate: boolean)=>void;
  featureType: string;
  saveRef?: React.MutableRefObject<(() => Promise<void>) | undefined>;
};

type commandType = {
  id: number;
  label: string;
  description: string;
  hasOptions: boolean;
  onClickHandler: Function;
  child: [];
  type: string;
  choiceType: string;
};

const CONDITION_TEXTAREA =
  "tw-h-8 tw-rounded tw-w-[95%] tw-bg-surface tw-text-ink tw-pl-0 tw-border-solid tw-border-edge-strong tw-border disabled:tw-bg-surface-sunken disabled:tw-text-ink-disabled";

const ConditionalRuleComponent = ({
  selectedItem,
  setUserProjectDataModels,
  userProjectDataModels,
  indexInfo,
  editId,
  ruleType,
  toggleMenu,
  createISRProject,
  featureType,
  saveRef,
}: ConditionalRuleComponentPropType) => {
  const [rules, setRules] = useState<RuleObjectStateType[]>([]);
  const [ruleState, setRuleState] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [conditionState, setConditionState] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [showMath, setShowMath] = useState<boolean>(false);
  const [dynamicCommandOption, setDynamicCommandOption] = useState<any[]>();
  const [commandOptions, setCommandOptions] = useState<
    RuleSuggestionOptionType[]
  >(RULE_SUGESSTION_OPTIONS);
  const [showSelectOptions, setShowSelectOptions] = useState<boolean>(false);
  const [selectRef, setSelectRef] = useState<any>();
  const [expressionRef, setExpressionRef] = useState<any>();
  const [conditionRef, setConditionRef] = useState<any>();
  const [ruleScope, setRuleScope] = useState<any>();
  const [propName, setPropName] = useState<string>(RULE_EMPTY_STRING);
  const [loading, setLoading] = useState<boolean>(false);
  const [mergeFieldList, setMergeFieldList] = useState<
    (
      | TField
      | {
          id: string | null | undefined;
          type: string;
          name: string;
          belongsToDataModel: boolean;
          dataConfiguration: TFieldDataConfiguration;
          additionalData: TFieldAdditionalData;
          rules: RuleObjectType[];
        }
    )[]
  >();
  const [ruleName, setRuleName] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [description, setDescription] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [dynamicFeatureOptions, setDynamicFeatureOptions] = useState<any[]>();
  const [stateFeatureType, setStateFeatureType] = useState<RuleOptionType>();
  const [feature, setFeature] = useState<RuleOptionType>();
  const [operator, setOperator] = useState<RuleOptionType>();
  const [activeInput, setActiveInput] = useState<string>();
  const [ruleExpList, setRuleExpList] = useState<TRuleObj[]>([]);
  const [hierarchyObject, setHierarchyObject] = useState<{ subModel: string, category: string, field: string }>({ subModel: "", category: "", field: "" });
  // Tracks whether THIS dialog session already created its draft rule via a first save.
  // `editId` is frozen (owned by the parent, only refreshed once the dialog is closed - see
  // RulesComponent) for the whole session, so once the draft exists, later saves must be
  // matched by position instead of by `id === editId`, or they fall through to "not found"
  // and push a duplicate rule. See okf/isr/e2e.md.
  const [hasCreatedDraft, setHasCreatedDraft] = useState<boolean>(false);

  const setFocusToInput = (callType: string = RULE_FUNCTION_EXPRESSION) => {
    if (callType === RULE_FUNCTION_EXPRESSION)
      if (expressionRef) expressionRef.focus();
      else if (conditionRef) conditionRef.focus();
  };

  useEffect(() => {
    fetchEditState();
  }, [selectedItem, userProjectDataModels]);

  useEffect(() => {
    if (ruleState && ruleState.endsWith("/")) {
      setShowMath(false);
      setDynamicCommandOption([]);
      setShowSelectOptions(true);
      setPropName(RULE_EMPTY_STRING);
    } else {
      setShowSelectOptions(false);
    }
    setFocusToInput();
  }, [ruleState]);

  useEffect(() => {
    if (conditionState && conditionState.endsWith("/")) {
      setShowMath(false);
      setDynamicCommandOption([]);
      setShowSelectOptions(true);
      setPropName(RULE_EMPTY_STRING);
    } else {
      setShowSelectOptions(false);
    }
    setFocusToInput("condition");
  }, [conditionState]);

  useEffect(() => {
    scrollToBottom();
  }, [showSelectOptions, dynamicCommandOption, dynamicFeatureOptions]);

  const isCategoryFeature = featureType === RULE_FUNCTION_CATEGORY;

  // Some persisted rules have `feature` but no `featureType` (saved before it was reliably
  // written - see okf/isr/e2e.md). Without it, fetchEditState below falls through to the
  // Field default and the Feature dropdown comes up blank whenever the id actually points at
  // a Submodel/Category/Connector. Re-derive it by locating the id among the rule's own
  // submodel (via `rule.subModel`, cheapest and most likely scope) and, failing that, every
  // submodel/top-level list in the project.
  const resolveMissingFeatureType = (
    featureId: string | null | undefined,
    subModelId: string | null | undefined
  ): number | undefined => {
    if (!featureId) return undefined;

    const scopedSubModel = subModelId
      ? userProjectDataModels?.project.dataModels.find((m) => m.id === subModelId)
      : undefined;
    if (scopedSubModel) {
      if (scopedSubModel.id === featureId) return 0;
      if (scopedSubModel.data?.fields?.some((f) => f.id === featureId)) return 1;
      if (scopedSubModel.data?.productCategories?.some((c) => c.id === featureId)) return 2;
      if (scopedSubModel.data?.connectors?.some((c) => c.id === featureId)) return 3;
    }

    if (userProjectDataModels?.project.dataModels?.some((m) => m.id === featureId)) return 0;
    if (userProjectDataModels?.project.fields?.some((f) => f.id === featureId)) return 1;
    if (userProjectDataModels?.project.productCategories?.some((c) => c.id === featureId)) return 2;
    if (userProjectDataModels?.project.connectors?.some((c) => c.id === featureId)) return 3;

    for (const model of userProjectDataModels?.project.dataModels ?? []) {
      if (model.data?.fields?.some((f) => f.id === featureId)) return 1;
      if (model.data?.productCategories?.some((c) => c.id === featureId)) return 2;
      if (model.data?.connectors?.some((c) => c.id === featureId)) return 3;
    }

    return undefined;
  };

  const fetchEditState = () => {
    let prevRule: RuleObjectStateType | undefined;
    let prevRules: RuleObjectStateType[];
    let localFeature: TField | TProductCategory | undefined;
    const categoryItem = selectedItem as TProductCategory;
    const belongsToDataModel = isCategoryFeature
      ? !!categoryItem?.data?.belongsToDataModel
      : !!(
          selectedItem &&
          "belongsToDataModel" in selectedItem &&
          selectedItem?.belongsToDataModel
        );
    if (belongsToDataModel) {
      if (isCategoryFeature) {
        prevRules =
          userProjectDataModels?.project.dataModels[
            indexInfo?.dataModelIndex ?? -1
          ]?.data.productCategories[indexInfo?.categoryIndex ?? -1]?.data
            ?.rules ?? [];
      } else {
        prevRules =
          userProjectDataModels?.project.dataModels[
            indexInfo?.dataModelIndex ?? -1
          ]?.data.fields[indexInfo?.fieldIndex ?? -1].rules ?? [];
      }
      if(prevRules.length > 0) {
        prevRule = prevRules.find((e) => e.id === editId);
        if (prevRule && prevRule.featureType === undefined && prevRule.feature) {
          const recoveredFeatureType = resolveMissingFeatureType(prevRule.feature, prevRule.subModel);
          if (recoveredFeatureType !== undefined) {
            prevRule = { ...prevRule, featureType: recoveredFeatureType };
          }
        }
        if(prevRule?.featureType === 2) {
          const subModel = userProjectDataModels?.project.dataModels.find((e) => e.id === prevRule?.subModel);
          localFeature = subModel?.data.productCategories.find((e) => e.id === prevRule?.feature);
        }
      }
    } else if (isCategoryFeature) {
      localFeature =
        userProjectDataModels?.project.productCategories[
          indexInfo?.categoryOutsideDataModelIndex ?? -1
        ];
      prevRules =
        userProjectDataModels?.project.productCategories[
          indexInfo?.categoryOutsideDataModelIndex ?? -1
        ]?.data?.rules ?? [];
    } else {
      localFeature =
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data;
      prevRules =
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data?.rules ?? [];
    }
    if (Array.isArray(prevRules)) {
      if (prevRules !== rules) setRules(prevRules);

      const localFeatureType = RULE_FEATURE_TYPE_OPTIONS.filter(
        (x) => x.id === prevRule?.featureType
      );
      setStateFeatureType(localFeatureType[0]);
      let fieldList: any[];
      switch (prevRule?.featureType) {
        case 0:
          fieldList = getSubModelsList();
          break;
        case 2:
          fieldList = getCategoryList();
          break;
        case 3:
          fieldList = getConnectorList();
          break;
        default:
          fieldList = getFieldsList();
          break;
      }
      setDynamicFeatureOptions(fieldList);
      const localFeatureVal = fieldList.filter(
        (x) => x?.id === (localFeature?.id ?? prevRule?.feature)
      );
      setFeature(localFeatureVal[0]);
      if (!editId && featureType === RULE_FUNCTION_FIELD) {
        const fieldTypeOption = RULE_FEATURE_TYPE_OPTIONS.find((x) => x.id === 1);
        setStateFeatureType(fieldTypeOption);
        const currentField = fieldList.find((x) => x.id === selectedItem?.id);
        if (currentField) setFeature(currentField);
        if (!operator) {
          const equalsOption = RULE_OPERATOR_OPTIONS.find((x) => x.id === 1);
          setOperator(equalsOption);
        }
      } else if (!editId && featureType === RULE_FUNCTION_CATEGORY) {
        const categoryTypeOption = RULE_FEATURE_TYPE_OPTIONS.find((x) => x.id === 2);
        setStateFeatureType(categoryTypeOption);
        const categoryList = getCategoryList();
        setDynamicFeatureOptions(categoryList);
        const currentCategory = categoryList.find((x) => x.id === selectedItem?.id);
        if (currentCategory) setFeature(currentCategory);
        if (!operator) {
          const equalsOption = RULE_OPERATOR_OPTIONS.find((x) => x.id === 1);
          setOperator(equalsOption);
        }
      }
      if (editId) {
        const ruleObj = prevRules.filter((rule: any) => {
          return rule.id === editId;
        });
        if (ruleObj?.length > 0) {
          const expList = (ruleObj[0]?.ruleExpList as TRuleObj[])?.map((x) => {
            if (x.ruleCondition && x.ruleExp) x.disabled = true;
            return x;
          });
          setRuleName(ruleObj[0]?.name);
          setDescription(ruleObj[0]?.description);
          setRuleScope(ruleObj[0]?.ruleScope);
          setRuleExpList(expList);
          const localOperator = RULE_OPERATOR_OPTIONS.filter(
            (x) => x.label === ruleObj[0].operator
          );
          setOperator(localOperator[0]);
        }
      } else {
        const expList = (
          prevRules[prevRules?.length - 1]?.ruleExpList as TRuleObj[]
        )?.map((x) => {
          if (x.ruleCondition && x.ruleExp) x.disabled = true;
          return x;
        });
        if (ruleName && ruleExpList) setRuleExpList(expList);
      }
    }
  };

  const scrollToBottom = () => {
    if (selectRef) selectRef.scrollIntoView({ behavior: "smooth" });
  };

  const getSubModelsList = () => {
    const localCommand = userProjectDataModels.project.dataModels.filter(
      (userProjectObject) => userProjectObject.type === RULE_FUNCTION_SUBMODEL
    );
    const retlocalCommand = localCommand.map((command) => {
      return {
        id: command.id,
        label: command.data.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_SUBMODEL,
        type: command.type,
      };
    });
    return retlocalCommand;
  };

  const getSubModelsFieldsList = (id: any) => {
    let localFieldModel = userProjectDataModels?.project.dataModels.filter(
      (model) => model.id === id
    );
    let localFields = localFieldModel[0]?.data?.fields ?? [];
    let retlocalFields = localFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_SUBMODEL_FIELD,
        type: command.type,
      };
    });
    return retlocalFields;
  };

  const getSubModelsFieldsChoiceList = (id: any) => {
    let localFields =
      mergeFieldList ??
      userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]
        ?.data.fields ??
      [];
    let subModel = userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.id
    let fieldObject = localFields.filter((x) => x.id === id);
    let optionToMap;
    if (fieldObject.length > 0) {
      optionToMap = fieldObject[0];
      let retlocalFields = optionToMap?.dataConfiguration?.choices?.map(
        (command: TAttributeChoice) => {
          return {
            id: command.av_id ?? command.id,
            label: command.av_value ?? command.value,
            description: RULE_EMPTY_STRING,
            hasOptions: false,
            child: [],
            choiceType: RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
            type: MULTI_CHOICE,
            field: id,
            subModel: subModel
          };
        }
      );
      return retlocalFields;
    }
  };

  const getFieldsList = () => {
    let localFields = userProjectDataModels?.project.fields ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id };
    });
    let submodelFieldList: TField[] = [];
    userProjectDataModels?.project?.dataModels?.forEach((subModels) => {
      submodelFieldList.push(
        ...subModels?.data?.fields?.map((y) => {
          const localObj = { ...y };
          localObj.name = `"${subModels.data.name}"."${y.name}"`;
          localObj.subModel = subModels?.id
          return localObj;
        })
      );
    });
    let mergeFields = [...newlocalFields, ...submodelFieldList];
    setMergeFieldList(mergeFields);
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_FIELD,
        type: command.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const getCategoryList = () => {
    let localFields = userProjectDataModels?.project?.productCategories ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id, type: x.type };
    });
    let submodelCategoryList: {
      id: string | null | undefined;
      compatioScore: boolean;
      type: string;
      name: string;
      belongsToDataModel: boolean;
      categories: {
        type: string;
        data: TCategory[];
      };
      transformations: TTransformation[];
      subModel?: string | null | undefined;
    }[] = [];

    userProjectDataModels?.project?.dataModels?.map((subModels) => {
      subModels?.data?.productCategories?.forEach((y) => {
        const localObj = { ...y };
        submodelCategoryList.push({
          ...localObj.data,
          name: `"${subModels.data.name}"."${y.data.name}"`,
          id: localObj.id,
          subModel: subModels?.id
        });
      });
      return subModels;
    });
    let mergeFields = [...newlocalFields, ...submodelCategoryList];
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command?.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_CATEGORY,
        type: command?.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const getConnectorList = () => {
    let localFields = userProjectDataModels?.project?.connectors ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id, type: x.type };
    });
    let submodelConnectorList: {
      id: string | null | undefined;
      type: string;
      name: string;
      isConsumable: boolean;
      belongsToDataModel: boolean;
      submodels: TClass[];
      subModel: string | undefined | null
    }[] = [];
    userProjectDataModels?.project?.dataModels?.forEach((subModels) => {
      subModels?.data?.connectors?.forEach((y) => {
        const localObj = { ...y };
        submodelConnectorList.push({
          ...localObj.data,
          name: `"${subModels.data.name}"."${y.data.name}"`,
          subModel: subModels?.id,
          id: localObj.id,
        });
      });
    });
    let mergeFields = [...newlocalFields, ...submodelConnectorList];
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command?.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_CONNECTOR,
        type: command?.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const updateRules = (localRules: RuleObjectStateType[]) => {
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      const newRules: RuleObjectType[] = localRules.map((x) => {
        if (x.type === ruleType)
          return {
            id: x.id,
            ruleExpList: x.ruleExpList,
            ruleScope: x.ruleScope ?? {},
            name: x.name,
            description: x.description ?? RULE_EMPTY_STRING,
            type: x.type,
            operator: x?.operator,
            feature: x?.feature,
            featureType: x?.featureType,
            subModel: x?.subModel,
          };
        else return x;
      });
      const categoryItem = selectedItem as TProductCategory;
      const belongsToDataModel = isCategoryFeature
        ? !!categoryItem?.data?.belongsToDataModel
        : !!(
            selectedItem &&
            "belongsToDataModel" in selectedItem &&
            selectedItem?.belongsToDataModel
          );

      if (belongsToDataModel) {
        const dataModelToUpdate =
          newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
        if (isCategoryFeature) {
          const categoryToUpdate =
            dataModelToUpdate?.data?.productCategories?.[
              indexInfo?.categoryIndex ?? -1
            ];
          if (categoryToUpdate && categoryToUpdate.data) {
            categoryToUpdate.data.rules = newRules;
          }
        } else if (
          dataModelToUpdate &&
          dataModelToUpdate.data &&
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]
        ) {
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1].rules =
            newRules;
        }
      } else if (isCategoryFeature) {
        const categoryToUpdate =
          newDataModels.project.productCategories[
            indexInfo?.categoryOutsideDataModelIndex ?? -1
          ];
        if (categoryToUpdate && categoryToUpdate.data) {
          categoryToUpdate.data.rules = newRules;
        }
      } else {
        const fieldToUpdate =
          newDataModels.project.fields[
            indexInfo?.fieldOutsideDataModelIndex ?? -1
          ];
        if (fieldToUpdate && fieldToUpdate.data) {
          fieldToUpdate.data.rules = newRules;
        }
      }
      return newDataModels;
    });
  };

  const handleOptionsClick = (
    optionObject: commandType,
    callType: string = RULE_FUNCTION_EXPRESSION
  ) => {
    const rule = ruleState && ruleState.slice(0, -1);
    const condition = conditionState && conditionState.slice(0, -1);
    switch (optionObject.id) {
      case 0:
        setDynamicCommandOption(getSubModelsList());
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      case 1:
        setDynamicCommandOption(getFieldsList());
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      case 2:
        setDynamicCommandOption(getCategoryList());
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      case 3:
        break;
      case 4:
        break;
      case 5:
        setShowMath(true);
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(rule);
        else setConditionState(condition);
        break;
      default:
        let localRuleState = rule + " " + optionObject.label + " ";
        let localcondition = condition + " " + optionObject.label + " ";
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localcondition);
        setDynamicCommandOption([]);
        break;
    }
  };


  const handleUpdatePropNameToRuleScope = (
    optionObject: any,
    concatString: string
  ) => {
    const id = optionObject?.id
    const type = optionObject?.type
    const submodel = optionObject?.subModel ? optionObject?.subModel : hierarchyObject?.subModel
    const field = optionObject?.field ? optionObject?.field : hierarchyObject?.field
    setRuleScope({
      ...ruleScope,
      [`${propName + concatString}`]: { id: id, type: type, subModel: submodel, field: field },
    });

    setPropName(RULE_EMPTY_STRING);
    setHierarchyObject({ subModel: '', category: '', field: '' })
  };
  const handleSubOptionsCLick = (
    optionObject: commandType,
    callType: string = RULE_FUNCTION_EXPRESSION
  ) => {
    let localRuleState =
      callType === RULE_FUNCTION_EXPRESSION ? ruleState : conditionState;
    const addition = '"' + optionObject.label + '"';
    switch (optionObject.choiceType) {
      case RULE_FUNCTION_SUBMODEL:
        const submodelString = addition + ".";
        localRuleState = localRuleState + submodelString;
        setPropName(submodelString);
        setDynamicCommandOption(getSubModelsFieldsList(optionObject.id));
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, subModel: optionObject?.id }
          return newObj
        })
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        break;
      case RULE_FUNCTION_SUBMODEL_FIELD:
        localRuleState = localRuleState + addition;
        // const subModelFieldOptions = getSubModelsFieldsChoiceList(
        //   optionObject.id
        // );
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        setPropName(propName + addition);
        // if (!subModelFieldOptions)
        handleUpdatePropNameToRuleScope(
          optionObject,
          addition
        );
        setDynamicCommandOption([]);
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        break;
      case RULE_FUNCTION_FIELD:
        const fieldOptions = getSubModelsFieldsChoiceList(optionObject.id);
        setPropName(propName + optionObject.label);
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        if (!fieldOptions)
          handleUpdatePropNameToRuleScope(
            optionObject,
            optionObject.label
          );
        setDynamicCommandOption(fieldOptions);
        if (callType === RULE_FUNCTION_EXPRESSION)
          setRuleState(localRuleState + optionObject.label);
        else setConditionState(localRuleState + optionObject.label);
        break;
      case RULE_FUNCTION_SUBMODEL_FIELD_CHOICE:
        const choiceString = "." + addition;
        localRuleState = localRuleState + choiceString;
        setPropName(propName + choiceString);
        handleUpdatePropNameToRuleScope(
          optionObject,
          choiceString
        );
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        setDynamicCommandOption([]);
        break;
      case RULE_FUNCTION_CATEGORY:
        const choiceString2 = addition;
        handleUpdatePropNameToRuleScope(
          optionObject,
          choiceString2
        );
        localRuleState = localRuleState + addition;
        setPropName(propName + localRuleState);
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        setDynamicCommandOption([]);
        break;
      default:
        if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(localRuleState);
        else setConditionState(localRuleState);
        setDynamicCommandOption([]);
        break;
    }
  };

  const onChangeHandler = (
    e: any,
    type = RULE_FUNCTION_PARENT,
    callType = RULE_FUNCTION_EXPRESSION
  ) => {
    if (type === RULE_FUNCTION_CHILD) {
      if (e.includes(RULE_DONE)) {
        setShowMath(false);
        setActiveInput(callType);
        setFocusToInput(callType);
        return;
      }
      if (e.includes(RULE_ADD_FIELD)) {
        setShowMath(false);
        setShowSelectOptions(true);
        setDynamicCommandOption([]);
        setActiveInput(callType);
        setFocusToInput(callType);
        return;
      }
      if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(e);
      else setConditionState(e);
    } else {
      if (callType === RULE_FUNCTION_EXPRESSION) setRuleState(e.target.value);
      else setConditionState(e.target.value);
    }
    setActiveInput(callType);
    setFocusToInput(callType);
  };

  const isValidMathExpression = (expression: string) => {
    try {
      const stack = [];
      const openingBrackets = ["(", "[", "{"];
      const closingBrackets = [")", "]", "}"];

      for (let i = 0; i < expression.length; i++) {
        const char = expression[i];

        if (openingBrackets.includes(char)) {
          stack.push(char);
        } else if (closingBrackets.includes(char)) {
          const correspondingOpeningBracket =
            openingBrackets[closingBrackets.indexOf(char)];

          if (
            stack.length === 0 ||
            stack.pop() !== correspondingOpeningBracket
          ) {
            return false;
          }
        }
      }

      return stack.length === 0;
    } catch (error) {
      return false;
    }
  };

  const onSaveHandler = async (
    type: string = RULE_FUNCTION_SAVE,
    paramRuleExpList: TRuleObj[]
  ) => {
    let localRules = [...rules];
    const localRuleExpList = paramRuleExpList.map((x) => {
      let newObj = { ...x };
      delete newObj.disabled;
      return newObj;
    });
    let message = RULE_EMPTY_STRING;
    // Once this session's draft rule exists (an earlier save already created it), amend it
    // by position - `editId` never becomes truthy for it while the dialog stays open, so
    // relying on `id === editId` alone would keep falling through to "not found" and push a
    // second copy of the same rule every time another condition is saved.
    const currentRuleIndex = editId
      ? localRules.findIndex((x) => x.id === editId)
      : hasCreatedDraft
      ? localRules.length - 1
      : -1;
    if (type === RULE_FUNCTION_EDIT || type === RULE_FUNCTION_DELETE || currentRuleIndex >= 0) {
      message = RULE_UPDATE_MESSAGE;
      if (currentRuleIndex >= 0) {
        localRules = localRules.map((x, i) => {
          if (i !== currentRuleIndex) return x;
          let newObj = { ...x };
          newObj.ruleExpList = localRuleExpList;
          newObj.ruleScope = ruleScope;
          newObj.name = ruleName;
          newObj.description = description;
          newObj.operator = operator?.label;
          newObj.feature = feature?.id;
          newObj.featureType = stateFeatureType?.id;
          newObj.subModel = feature?.subModel;
          return newObj;
        });
      }
      if (type === RULE_FUNCTION_DELETE) updateRules(localRules);
    } else {
      message = RULE_SAVE_MESSAGE;
      localRules.push({
        ruleExpList: localRuleExpList,
        name: ruleName,
        description: description,
        type: ruleType,
        ruleScope: ruleScope,
        operator: operator?.label,
        feature: feature?.id,
        featureType: stateFeatureType?.id,
        subModel: feature?.subModel,
      });
    }
    if (ruleName) {
      if (ruleState && conditionState) {
        if (
          isValidMathExpression(ruleState) &&
          isValidMathExpression(conditionState)
        ) {
          setRules(localRules);
          updateRules(localRules);
          setLoading(true);
          await createISRProject(true);
          setLoading(false);
          if (!editId) setHasCreatedDraft(true);
          resetState();
          setTimeout(() => {
            toast.success(message);
          }, 1000);
        } else {
          toast.info(RULE_VALIDATION_MESSAGE);
        }
      }
    } else toast.info(RULE_NAME_MANDATORY_MESSAGE);
  };

  const resetState = () => {
    setShowMath(false);
    setShowSelectOptions(false);
    setDynamicCommandOption([]);
    setRuleState(RULE_EMPTY_STRING);
    setConditionState(RULE_EMPTY_STRING);
  };

  const onInputChangeHandler = (e: any, type: string) => {
    if (type === RULE_FUNCTION_RULE_NAME) {
      setRuleName(e.target.value);
    } else {
      setDescription(e.target.value);
    }
  };

  const handleFeatureType = (e: any) => {
    /*
      String-coerced compare, same pattern as handleOperator below. The strict
      `x?.id === e` never matched — the ids are numbers, `e` arrives as the
      select's string value — so a MANUAL Feature Type change left
      stateFeatureType undefined and every rule saved that way carried
      `featureType: undefined` (the edit path expects the numeric id). The
      native select hid it: React treats value={undefined} as uncontrolled, so
      the DOM kept showing the choice while the state said nothing.
    */
    const localFeatureType = RULE_FEATURE_TYPE_OPTIONS.filter(
      (x) => `${x?.id}` === `${e}`
    );
    setStateFeatureType(localFeatureType[0]);
    switch (e) {
      case RULE_FUNCTION_0:
        setDynamicFeatureOptions(getSubModelsList());
        break;
      case RULE_FUNCTION_1:
        setDynamicFeatureOptions(getFieldsList());
        break;
      case RULE_FUNCTION_2:
        setDynamicFeatureOptions(getCategoryList());
        break;
      case RULE_FUNCTION_3:
        setDynamicFeatureOptions(getConnectorList());
        break;
      default:
        break;
    }
  };

  const handleFeature = (e: any) => {
    const localFeature = (dynamicFeatureOptions as RuleOptionType[])?.filter(
      (x) => x?.id === e
    );
    setFeature(localFeature[0]);
  };

  const handleOperator = (e: any) => {
    const localOperator = RULE_OPERATOR_OPTIONS?.filter(
      (x) => `${x?.id}` === e
    );
    setOperator(localOperator[0]);
  };

  const handleEdit = async (id: string | undefined) => {
    const prevEdited = ruleExpList.filter((x) => x.disabled === false) ?? [];
    if(prevEdited.length > 0) {
      await handleDone(prevEdited[0].id, RULE_FUNCTION_SAVE)
    }
    const localRuleExpList = ruleExpList.map((x) => {
      if (x.id === id) {
        x.disabled = false;
        setConditionState(x.ruleCondition);
        setRuleState(x.ruleExp);
      } else x.disabled = true;
      return x;
    });
    setRuleExpList(localRuleExpList);
  };

  const handleDelete = (id: string | undefined) => {
    let localRuleExpList: TRuleObj[] = ruleExpList;
    setRuleExpList((prev) => {
      const next = prev?.filter((x) => x.id !== id);
      localRuleExpList = [...next];
      return next;
    });
    onSaveHandler(RULE_FUNCTION_DELETE, localRuleExpList);
    resetState();
  };

  const handleDone = async (
    id: string | undefined | null = undefined,
    callType: string = RULE_FUNCTION_SAVE
  ) => {
    if(loading) {
        toast.info('Please wait, saving rule...');
        return;
    }
    if(callType === RULE_FUNCTION_ADD) {
      const unsavedRules = ruleExpList?.filter((x) => x.id === undefined) ?? [];
      if(unsavedRules.length > 0) {
        toast.info('Please save rule to continue');
        return;
      }
    }
    let editFlag = false;
    const localRuleExpList =
      ruleExpList?.map((x) => {
        if (x.id && x.id === id) {
          if (conditionState) x.ruleCondition = conditionState;
          if (ruleState) x.ruleExp = ruleState;
          editFlag = true;
        } else {
          if (!editFlag && !x.ruleCondition && conditionState)
            x.ruleCondition = conditionState;
          if (!editFlag && !x.ruleExp && ruleState) x.ruleExp = ruleState;
        }
        x.disabled = true;
        return x;
      }) ?? [];
    if (callType === RULE_FUNCTION_ADD) {
      localRuleExpList?.push({
        ruleCondition: RULE_EMPTY_STRING,
        ruleExp: RULE_EMPTY_STRING,
      });
    }
    setRuleExpList(localRuleExpList);
    await onSaveHandler(
      editId ? RULE_FUNCTION_EDIT : RULE_FUNCTION_SAVE,
      localRuleExpList
    );
  };

  const saveRules = async () => {
    if (loading) {
      toast.info('Please wait, saving rule...');
      return;
    }
    let currentEditingRuleId: string | undefined | null = undefined;
    const currentEditingRules = ruleExpList?.filter((x) => x.disabled === false) ?? [];
    if (currentEditingRules.length > 0) {
      currentEditingRuleId = currentEditingRules[0].id;
    }
    let editFlag = false;
    const localRuleExpList =
        ruleExpList?.map((x) => {
          if (x.id && x.id === currentEditingRuleId) {
            if (conditionState) x.ruleCondition = conditionState;
            if (ruleState) x.ruleExp = ruleState;
            editFlag = true;
          } else {
            if (!editFlag && !x.ruleCondition && conditionState)
              x.ruleCondition = conditionState;
            if (!editFlag && !x.ruleExp && ruleState) x.ruleExp = ruleState;
          }
          x.disabled = true;
          return x;
        }) ?? [];
    if (!ruleName) {
      toast.info(RULE_NAME_MANDATORY_MESSAGE)
      return;
    }
    let message = RULE_SAVE_MESSAGE;
    let localRules = [...rules];
    // Same reasoning as onSaveHandler: `editId` stays null for this whole dialog session when
    // creating a new rule, so once an earlier save already created the draft, match it by
    // position rather than by an `id` that will never equal the frozen `editId`.
    const ruleIndex = editId
      ? localRules.findIndex((x) => x.id === editId)
      : hasCreatedDraft
      ? localRules.length - 1
      : -1;
    if (ruleIndex >= 0) {
      localRules[ruleIndex].ruleExpList = ruleExpList;
      localRules[ruleIndex].name = ruleName;
      localRules[ruleIndex].description = description;
      localRules[ruleIndex].type = ruleType;
      localRules[ruleIndex].ruleScope = ruleScope;
      localRules[ruleIndex].operator = operator?.label;
      localRules[ruleIndex].feature = feature?.id;
      localRules[ruleIndex].featureType = stateFeatureType?.id;
      localRules[ruleIndex].subModel = feature?.subModel;
    } else {
      localRules.push({
        ruleExpList: localRuleExpList,
        name: ruleName,
        description: description,
        type: ruleType,
        ruleScope: ruleScope,
        operator: operator?.label,
        feature: feature?.id,
        featureType: stateFeatureType?.id,
        subModel: feature?.subModel,
      });
    }
    setRules(localRules);
    updateRules(localRules);
    setLoading(true);
    await createISRProject(true);
    setLoading(false);
    if (!editId) setHasCreatedDraft(true);
    setTimeout(() => {
      toast.success(message);
    }, 1000);
    setRuleExpList(localRuleExpList);
  };

  useEffect(() => {
    if (saveRef) saveRef.current = saveRules;
  });

  const isFeatureLocked = featureType === RULE_FUNCTION_FIELD || featureType === RULE_FUNCTION_CATEGORY;

  return (
    /* The legacy cart-style global expanded at the call site onto role tokens
       (it hardcodes white/#e5e5ea and must never be re-skinned globally). */
    <div className="tw-rounded tw-bg-surface-sunken tw-box-border tw-w-full tw-h-screen tw-border tw-border-solid tw-border-edge tw-py-2 tw-px-4">
      <TextField
        label={RULE_NAME}
        required
        className="tw-m-2"
        value={ruleName ?? RULE_EMPTY_STRING}
        onChange={(_value, e) => { if (e) onInputChangeHandler(e, RULE_FUNCTION_RULE_NAME); }}
        data-testid="rules-conditionalrulecomponent-input-1"
      />
      <TextField
        label={RULE_DESCRIPTION}
        className="tw-m-2"
        value={description ?? RULE_EMPTY_STRING}
        onChange={(_value, e) => { if (e) onInputChangeHandler(e, RULE_FUNCTION_DESCRIPTION); }}
        data-testid="rules-conditionalrulecomponent-input-2"
      />
      {/* DS Dropdowns. Each onChange String-coerces the option value before
          handing it to the SAME handler the native selects called — the
          handlers' string contract (`e.target.value`) is preserved verbatim.
          The DS trigger carries `title` with the full label, which is what
          the bespoke hover-tooltip wrapper on the second one existed for. */}
      <div className="tw-flex tw-w-full tw-rounded-md tw-mt-4 tw-gap-4">
        {/* release-sept-29: a Field or Category rule has no Feature Type to pick, so
            the whole control is withheld rather than shown empty (§ 533c69f83). The
            control itself is the DS Dropdown from the design-system pass. */}
        <div
          className={`tw-w-[30%] tw-ml-2 ${isFeatureLocked ? 'tw-hidden' : ''}`}
          data-testid="rules-conditionalrulecomponent-featuretype-wrap"
        >
          <Dropdown
            label={RULE_FEATURE_TYPE}
            placeholder={RULE_SELECT}
            options={RULE_FEATURE_TYPE_OPTIONS.map((item) => ({
              value: item?.id ?? RULE_EMPTY_STRING,
              label: item?.label ?? RULE_EMPTY_STRING,
            }))}
            value={stateFeatureType?.id}
            onChange={(value) => handleFeatureType(String(value))}
            data-testid="rules-conditionalrulecomponent-select-3"
          />
        </div>
        <div className="tw-w-[30%] tw-ml-2 ">
          {/* `disabled` is release-sept-29's lock: a Field or Category rule has its
              feature fixed by the rule type, so the choice is shown but not offered.
              The hand-rolled lock it replaces (opacity + a grey fill + an inline
              arrow override) is the DS disabled state now, and the hover-tooltip
              wrapper it sat in is gone because the DS trigger already carries
              title={selectedOption?.label || placeholder} — the same full label on
              hover, which is the only reason that wrapper existed. (Spelled without
              the component's name on purpose: the source-invariant test below scans
              this file for it.) */}
          <Dropdown
            label={RULE_FEATURE}
            placeholder={RULE_SELECT}
            options={(dynamicFeatureOptions ?? []).map((item) => ({
              value: item?.id ?? RULE_EMPTY_STRING,
              label: item?.label ?? RULE_EMPTY_STRING,
            }))}
            value={feature?.id}
            onChange={(value) => handleFeature(String(value))}
            disabled={isFeatureLocked}
            data-testid="rules-conditionalrulecomponent-select-4"
          />
        </div>
        <div className="tw-w-[30%] tw-ml-4 ">
          <Dropdown
            label={RULE_OPERATOR}
            placeholder={RULE_SELECT}
            options={RULE_OPERATOR_OPTIONS.map((item) => ({
              value: item?.id ?? RULE_EMPTY_STRING,
              label: item?.label ?? RULE_EMPTY_STRING,
            }))}
            value={operator?.id}
            onChange={(value) => handleOperator(String(value))}
            data-testid="rules-conditionalrulecomponent-select-5"
          />
        </div>
      </div>
      <div>
        <FieldTitle label={RULE_RULE} className="tw-ml-2 tw-mt-2" />
        {ruleExpList?.map((x, i) => (
          <div
            key={i}
            /* The unprefixed Bootstrap `border` is gone; the card is a surface
               on an edge border sitting on the sunken drawer ground. */
            className="tw-border tw-border-edge tw-p-4 tw-w-full tw-h-full tw-bg-surface tw-justify-center tw-items-center tw-rounded-md tw-mt-4 tw-gap-4"
          >
            <div>
              <div className="tw-w-[100%] tw-flex tw-flex-row ">
                <label className="tw-w-[90%] tw-text-ink">{RULE_EXPRESSION}</label>
                {/* EditIcon draws currentColor and follows the secondary
                    accent ink; the danger Delete re-inks DeleteIcon's
                    hardcoded #747593 strokes via icon-follow-ink. */}
                <Button
                  variant="secondary"
                  size="sm"
                  className="tw-mr-1"
                  aria-label={x?.disabled ? "Edit" : undefined}
                  data-testid="rules-conditionalrulecomponent-button-6"
                  onClick={() => {
                    x?.disabled
                      ? handleEdit(x.id)
                      : handleDone(x.id, RULE_FUNCTION_SAVE);
                  }}
                >
                  {x?.disabled ? <EditIcon /> : RULE_DONE}
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="icon-follow-ink"
                  aria-label="Delete"
                  data-testid="rules-conditionalrulecomponent-button-7"
                  onClick={() => {
                    handleDelete(x?.id);
                  }}
                >
                  <DeleteIcon />
                </Button>
              </div>
              <div className="tw-box-border tw-w-[100%] tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-0.5 m-2 tw-gap-[2px] tw-text-sm">
                <textarea data-testid="rules-conditionalrulecomponent-textarea-8"
                  className={CONDITION_TEXTAREA}
                  disabled={x?.disabled}
                  value={!x?.disabled ? ruleState : x?.ruleExp}
                  onChange={(e) => onChangeHandler(e, RULE_FUNCTION_PARENT)}
                  ref={(el) => setExpressionRef(el)}
                />
              </div>
            </div>
            <div>
              <label className="tw-text-ink">{RULE_CONDITION}</label>
              <div className="tw-box-border tw-w-[100%] tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-0.5 m-2 tw-gap-[2px] tw-text-sm">
                <textarea data-testid="rules-conditionalrulecomponent-textarea-9"
                  className={CONDITION_TEXTAREA}
                  value={!x?.disabled ? conditionState : x?.ruleCondition}
                  disabled={x?.disabled}
                  onChange={(e) =>
                    onChangeHandler(
                      e,
                      RULE_FUNCTION_PARENT,
                      RULE_FUNCTION_CONDITION
                    )
                  }
                  ref={(el) => setConditionRef(el)}
                />
              </div>
            </div>
          </div>
        ))}
        <Button
          variant="secondary"
          size="sm"
          className="tw-mt-2"
          data-testid="rules-conditionalrulecomponent-button-10"
          onClick={() => handleDone(null, RULE_FUNCTION_ADD)}
        >
          {CREATE_NEW_CONDITION}
        </Button>
      </div>
      {showMath && (
        <MathOperator
          state={
            activeInput === RULE_FUNCTION_EXPRESSION
              ? ruleState
              : conditionState
          }
          handleState={(e: string) =>
            onChangeHandler(e, RULE_FUNCTION_CHILD, activeInput)
          }
        />
      )}
      {showSelectOptions && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={commandOptions}
            onClickHandler={(option: any) => {
              handleOptionsClick(option, activeInput);
            }}
          />
        </div>
      )}
      {dynamicCommandOption && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={dynamicCommandOption}
            onClickHandler={(option: any) => {
              handleSubOptionsCLick(option, activeInput);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ConditionalRuleComponent;
